// extracted by mini-css-extract-plugin
export default {"fullWidth":"Gl-z","image":"Hl-z","lazyLoadPicture":"Il-z","lazyLoadSpinner":"Jl-z","lazyLoadSpin":"Kl-z","lazyLoadImage":"Ll-z","hasStyledAspectRatio":"Ml-z"};